/**
 * Flair Rugs — Rafraîchissement dynamique de la barre de livraison offerte
 * S'accroche aux événements déjà émis par theme.js (Impulse) :
 *   - ajaxProduct:added  -> ajout produit depuis une page produit / quick add
 *   - cart:updated       -> changement de quantité dans le panier
 * Ne modifie pas theme.js.
 */
(function () {
  function updateShippingBar() {
    var bar = document.getElementById('FlairShippingBar');
    if (!bar) return;

    var threshold = parseInt(bar.dataset.threshold, 10);
    var unlockedMessage = bar.dataset.unlockedMessage;
    var remainingTemplate = bar.dataset.remainingTemplate;

    // theme.cart.getCart() est déjà défini dans theme.js
    theme.cart.getCart().then(function (cart) {
      var cartTotal = cart.total_price;
      var html = '';

      if (cartTotal >= threshold) {
        html =
          '<div class="flair-shipping-bar__message flair-shipping-bar__message--unlocked">' +
            unlockedMessage +
          '</div>' +
          '<div class="flair-shipping-bar__track">' +
            '<div class="flair-shipping-bar__fill flair-shipping-bar__fill--complete"></div>' +
          '</div>';
      } else {
        var remaining = threshold - cartTotal;
        var remainingMoney = theme.Currency.formatMoney(remaining, theme.settings.moneyFormat);
        var progress = Math.floor((cartTotal * 100) / threshold);
        var message = remainingTemplate.replace('AMOUNT', remainingMoney);

        html =
          '<div class="flair-shipping-bar__message">' + message + '</div>' +
          '<div class="flair-shipping-bar__track">' +
            '<div class="flair-shipping-bar__fill" style="width: ' + progress + '%"></div>' +
          '</div>';
      }

      bar.innerHTML = html;
    });
  }

  document.addEventListener('ajaxProduct:added', updateShippingBar);
  document.addEventListener('cart:updated', updateShippingBar);
})();